import React, { useState, useContext, useRef, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AuthContext } from "../../comum/Context/auth.jsx";
import { api } from "../../services/api.js";
import { setLoginToday } from "./../Utils/auth.js";

import logoSmall from "../../comum/assets/arbor.png";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import SentimentoPopup from "../Components/Sentimento/SentimentoPopup.jsx";

import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./index.css";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const senhaRef = useRef(null);
  const emailRef = useRef(null);

  const { setLogado } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [msgerro, setmsgErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [mostrarSentimento, setMostrarSentimento] = useState(false);
  const [chapaUsuario, setChapaUsuario] = useState(null);
  const [mostrarSenha, setMostrarSenha] = useState(false);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const redirectTo =
    new URLSearchParams(location.search).get("redirect") || "/arbor/home";

  const toggleShowSenha = () => {
    setMostrarSenha(!mostrarSenha);
  };

  const LoginArbor = () => {
    setLogado(false);

    // 🔹 FAZ BACKUP DOS FAVORITOS E HISTÓRICO DE POP-UPS ANTES DE LIMPAR A SESSÃO
    const chavesPreservadas = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith("favoritos_") || key.startsWith("popupAeflorVisto_"))) {
        chavesPreservadas[key] = localStorage.getItem(key);
      }
    }

    localStorage.clear();

    // 🔹 RESTAURA OS DADOS SALVOS
    Object.keys(chavesPreservadas).forEach((key) => {
      localStorage.setItem(key, chavesPreservadas[key]);
    });

    const data = { usuario: email, senha, versao: "1.2" };

    api
      .post("/usuario/consultausuario/web", data)
      .then((retorno) => {
        const res = retorno.data;
        setSucesso(res.SUCESSO);
        setmsgErro(res.ERRO);
        localStorage.setItem("certificado", res.CERTIFICADO);

        if (res.SUCESSO === "S") {
          const temPermissaoPonto = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "RHEXCLUSIVO" &&
              p.usrconf_campo === "RHEXVPONTOAUTORIZA" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permitePonto", temPermissaoPonto ? "S" : "N");

          const temPermissaoRegional = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "RHEXCLUSIVO" &&
              p.usrconf_campo === "RHEXVCOMUNICADOREG" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permiteRegional", temPermissaoRegional ? "S" : "N");

          const temPermissaoComunicado = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "RHEXCLUSIVO" &&
              p.usrconf_campo === "RHEXVCOMUNICADOAUT" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permiteComunido", temPermissaoComunicado ? "S" : "N");

          const temPermissaoDiretor = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "CARGO" &&
              p.usrconf_campo === "DIRETOR" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("diretor", temPermissaoDiretor ? "S" : "N");

          const temPermissaoSap = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "SAP" &&
              p.usrconf_campo === "SAPADMIN" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("SAPADM", temPermissaoSap ? "S" : "N");

          const permitePesquisaColeta = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "PESQUISACOLETA" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("PESQUISACOLETA", permitePesquisaColeta ? "S" : "N");

          const temCadastroCheckListti = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "TICHECKCADASTRO" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("TICADCHECKLIST", temCadastroCheckListti ? "S" : "N");

          const TemVistoria = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "VISTORIA" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("vistoriaLoja", TemVistoria ? "S" : "N");

          const ConsultaFerias = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "FERIAS" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("FERIAS", ConsultaFerias ? "S" : "N");

          const temConciliaCartao = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "CONCILIACARTAO" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("CONCILIACARTAO", temConciliaCartao ? "S" : "N");

          const permiteFichaFinanceira = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "FICHAFINANCEIRA" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("FICHAFINANCEIRA", permiteFichaFinanceira ? "S" : "N");

          const permiteFichaFinanceiraAP = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "FICHAFINANCEIRAAPROV" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("FICHAFINANCEIRAAPROV", permiteFichaFinanceiraAP ? "S" : "N");

          const permiteControleEpi = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "CONTROLEEPI" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("CONTROLEEPI", permiteControleEpi ? "S" : "N");          

          const permiteDashBoardRH = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "FLOSOFTNEW" &&
              p.usrconf_campo === "RH" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("RHDASHBOARD", permiteDashBoardRH ? "S" : "N");

          const temCheckList = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "CHECKLIST" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("CHECKLIST", temCheckList ? "S" : "N");

          let lojasPermitidas = res.LOJAS || [];

          const permiteVendas = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "VENDAS" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permiteVendas", permiteVendas ? "S" : "N");

          const PermiteInventario = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "INVENTARIO" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("INVENTARIO", PermiteInventario ? "S" : "N");

          const acessosSetorRaw = res.PROGRAMAS
            ?.filter(p => p.usrconf_modulo === "CHAMADO" && p.usrconf_campo === "SETOR")
            .map(p => p.usrconf_acesso);
          
          const acessosSetor = acessosSetorRaw && acessosSetorRaw.length > 0
            ? acessosSetorRaw[0].split(',')
            : [];
          localStorage.setItem("setorchamado", JSON.stringify(acessosSetor));

          const lojaBackend = res.LOJA || res.lojap;
          const lojaPri = res.PROGRAMAS?.find(
            (p) =>
              p.usrconf_modulo === "USRLOJA" &&
              p.usrconf_campo === "NUMLOJA"
          );

          let lojaPrincipal = null;

          if (lojaPri?.usrconf_acesso) {
            const parsed = parseInt(lojaPri.usrconf_acesso, 10);
            if (!isNaN(parsed)) lojaPrincipal = parsed;
          }

          if (lojaPrincipal === null && lojaBackend) {
            const parsed = parseInt(lojaBackend, 10);
            if (!isNaN(parsed)) lojaPrincipal = parsed;
          }

          if (lojaPrincipal !== null) {
            const lojaFormatada = String(lojaPrincipal).padStart(2, "0");
            localStorage.setItem("lojaprincipal", lojaFormatada);
          }

          let lojasPermitidasFinal = Array.isArray(lojasPermitidas)
            ? [...lojasPermitidas]
            : [];

          if (lojasPermitidasFinal.length === 0 && lojaPri?.usrconf_acesso) {
            const parsed = parseInt(lojaPri.usrconf_acesso, 10);
            if (!isNaN(parsed)) {
              lojasPermitidasFinal = [parsed];
            }
          }

          if (lojasPermitidasFinal.length === 0 && lojaPrincipal !== null) {
            lojasPermitidasFinal = [lojaPrincipal];
          }

          lojasPermitidasFinal = lojasPermitidasFinal
            .filter((l) => !isNaN(l))
            .map((l) => String(l).padStart(2, "0"))
            .sort((a, b) => parseInt(a) - parseInt(b));

          localStorage.setItem(
            "lojasPermitidas",
            JSON.stringify(lojasPermitidasFinal)
          );

          const lojaSelecionada =
            lojaPrincipal !== null
              ? String(lojaPrincipal).padStart(2, "0")
              : lojasPermitidasFinal[0] || null;

          if (lojaSelecionada) {
            localStorage.setItem("loja", lojaSelecionada);
            localStorage.setItem("lojaSelecionada", lojaSelecionada);
          }

          localStorage.setItem(
            "pontoAutorizado",
            temPermissaoPonto ? "S" : "N"
          );

          localStorage.setItem("usuarioInfo", JSON.stringify(res));

          setLoginToday(data.usuario, lojaSelecionada, res.SAP, null);
          localStorage.removeItem("codigorest");
          setChapaUsuario(data.usuario);
          setLogado(true);

          localStorage.setItem("sentido", res.SENTIMENTO);
          localStorage.setItem("msg", res.MENSAGENS);
          if (res.SENTIMENTO === "0") {
            setMostrarSentimento(true);
          }
        } else {
          localStorage.setItem("logado", "N");
          localStorage.setItem("acessoSAP", "N");
          setLogado(false);
        }
      })
      .catch((err) => {
        console.error("Erro de login:", err);
        localStorage.setItem("logado", "N");
        localStorage.setItem("acessoSAP", "N");
        setLogado(false);
        setSucesso("N");
        setmsgErro("Erro de comunicação com o servidor");
      });
  };

  useEffect(() => {
    if (sucesso === "S" && !mostrarSentimento) {
      if (chapaUsuario?.startsWith("900010")) {
        navigate("/arbor/home/");
      } else if (chapaUsuario?.startsWith("900001")) {
        navigate("/arbor/home/");
      } else if (chapaUsuario?.startsWith("90")) {
        navigate("/arbor/restaurante/");
      } else {
        navigate("/arbor/home/");
      }
    }
  }, [sucesso, mostrarSentimento, redirectTo, navigate, chapaUsuario]);

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Menu modulo="login" />

      <div className="form-container">
        <form className="form-signin text-center" onSubmit={(e) => e.preventDefault()}>
          <img className="img-login" src={logoSmall} alt="Arbor Web" />

          <div className="form-floating">
            <input
              type="number"
              id="floatingInput"
              className="form-control"
              placeholder="Matrícula"
              value={email}
              ref={emailRef}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  senhaRef.current?.focus();
                }
              }}
            />
            <label htmlFor="floatingInput">Matrícula</label>
          </div>

          <div className="form-floating position-relative">
            <input
              type={mostrarSenha ? "text" : "password"}
              id="floatingPassword"
              className="form-control pe-5"
              placeholder="Senha"
              ref={senhaRef}
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && email !== "") {
                  e.preventDefault();
                  LoginArbor();
                }
              }}
            />
            <label htmlFor="floatingPassword">Senha</label>
            <button
              type="button"
              className="btn-eye-toggle"
              onClick={toggleShowSenha}
              tabIndex="-1"
              title={mostrarSenha ? "Ocultar senha" : "Exibir senha"}
            >
              {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button
            type="button"
            className="w-100 btn btn-lg btn-login-arbor"
            onClick={LoginArbor}
          >
            Acessar Sistema
          </button>

          {sucesso === "N" && (
            <div className="alert alert-danger mt-3 mb-0" role="alert">
              {msgerro}.
            </div>
          )}

          <div className="mt-3">
            <Link to="/arbor/esqueci-senha" className="link-esqueci-senha">
              Esqueci a Senha / Cadastrar
            </Link>
          </div>

          <p className="text-copyright">
            &copy; Desenvolvido por F2 Enterprise
          </p>
        </form>
      </div>

      {mostrarSentimento && (
        <SentimentoPopup
          chapa={chapaUsuario}
          onClose={() => setMostrarSentimento(false)}
        />
      )}

      <Footer />
    </div>
  );
}

export default Login;